<nav class="horizontal-nav not-printable" *ngIf="isMenuVisible">
  <ul class="horizontal-menu">
    <li *ngFor="let menuItem of menu" class="horizontal-menu-item">
      <div class="menu-button" (click)="onParentExpand($event, menuItem)">
        <mat-icon>{{ menuItem.icon }}</mat-icon>
        <span>{{ menuItem.name }}</span>
        <mat-icon *ngIf="menuItem.children">expand_more</mat-icon>
      </div>

      <!-- Dropdown for children -->
      <ul class="dropdown-menu" [ngClass]="{'has-children': menuItem.children?.length > 0}"
        *ngIf="menuItem.children?.length && isParentExpanded && expandedParentName === menuItem.name">
        <li *ngFor="let child of menuItem.children" class="dropdown-menu-item"
            [ngClass]="{'has-submenu': child.children?.length > 0}">
          <!-- Child item with its own children (sub-submenu) -->
          <ng-container *ngIf="child.children?.length > 0; else leafChild">
            <div class="submenu-trigger no-close" (click)="onChildParentExpand($event, child); $event.stopPropagation()">
              <mat-icon *ngIf="child.icon" class="no-close">{{ child.icon }}</mat-icon>
              <span class="no-close">{{ child.name }}</span>
              <mat-icon class="no-close submenu-arrow">chevron_right</mat-icon>
            </div>
            <!-- Sub-submenu -->
            <ul class="sub-dropdown-menu" *ngIf="isChildParentExpanded && expandedChildParentName === child.name">
              <li *ngFor="let subChild of child.children" class="child" (click)="onChildNavigate(subChild)">
                <mat-icon *ngIf="subChild.icon" class="child">{{ subChild.icon }}</mat-icon>
                <span class="child">{{ subChild.name }}</span>
              </li>
            </ul>
          </ng-container>
          <!-- Leaf child (no sub-children) -->
          <ng-template #leafChild>
            <div class="leaf-item" (click)="onChildNavigate(child)">
              <mat-icon *ngIf="child.icon">{{ child.icon }}</mat-icon>
              <span>{{ child.name }}</span>
            </div>
          </ng-template>
        </li>
      </ul>
    </li>
    <li class="dropdown-collapse-button" (click)="collapseMenu()">
      <mat-icon>close</mat-icon>
      <span>Collapse</span>
   </li>
  </ul>
</nav>